export default class GenericAdsAdapter {
  initProperties() {
    this.isGeneric = true;
  }

  getVersion() {
    return '7.0.10-videojs-ads-jsclass';
  }

  registerListeners() {
    this.references = {
      adstart: this.adStartListener.bind(this),
      adend: this.adEndListener.bind(this),
      adskip: this.adSkipListener.bind(this),
      adserror: this.errorListener.bind(this),
      'ads-click': this.clickListener.bind(this)
    };
    if (this.player) {
      for (var key in this.references) {
        this.player.on(key, this.references[key]);
      }
    }
  }

  unregisterListeners() {
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key]);
      }
      delete this.references;
    }
  }

  adStartListener(e) {
    this.firePlayerLog('adStartListener', {});
    this.fireStart();
    this.fireJoin();
  }

  adEndListener(e) {
    this.firePlayerLog('adEndListener', {});
    this.fireStop();
  }

  adSkipListener(e) {
    this.firePlayerLog('adSkipListener', {});
    this.fireSkip();
  }

  errorListener(e) {
    this.firePlayerLog('adErrorListener', {});
    this.fireError();
  }

  clickListener(e) {
    this.firePlayerLog('adClickListener', {});
    this.fireClick();
  }
}